import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-jinyong",
  "use": "icon-jinyong-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-jinyong\"><path d=\"M512 938.667A426.667 426.667 0 1 1 938.667 512 426.667 426.667 0 0 1 512 938.667zM165.12 512a346.496 346.496 0 0 0 564.053 269.867l-490.24-482.603A343.723 343.723 0 0 0 165.12 512zM512 165.333a345.13 345.13 0 0 0-217.173 76.8l490.24 482.56a343.339 343.339 0 0 0 73.386-212.736A346.88 346.88 0 0 0 512 165.333z\" p-id=\"12678\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol